import React from "react";
import ChatbotImg from "../../../assets/imgs/ai-chat-logo.svg";
import MultiLineScroll from "../../Chatbot/AiChatbotSeachModal/Components/ScrollLine";
import { SelectLeagueButton } from "../../LeagueSync/SelectLeagueButton/SelectLeagueButton";
import { BetaBadge } from "../../BetaBadge/BetaBadge";

// Define props interface for the component
interface AiEmptyChatProps {
  dataItems?: any[];
}

export const AiEmptyChat: React.FC<AiEmptyChatProps> = ({ dataItems = [] }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="w-[120px] flex items-center justify-center">
          <SelectLeagueButton />
        </div>

       {/* <BetaBadge /> */}
      </div>

      <div className="flex mt-[60px] items-center text-center justify-center flex-col gap-[30px] px-5">
        <img src={ChatbotImg} alt="Chatbot" className="" />
        <div className="text-[20px] font-medium chatbot-ai-header-text">
          Your Ultimate Football Agent
        </div>
      </div>

      <div className="mt-6 w-full">
        <MultiLineScroll dataItems={dataItems} />
      </div>
    </div>
  );
};
